import { format, isToday, isTomorrow, isYesterday, parseISO } from 'date-fns';
import { TradeState, TradeViewVariant } from '../types/trade';
import { formatNumber } from '../utils/localization';
import renderLocale from './renderLocale';

/**
 * List: Active today at 1:00 pm
 * VDP: Launching today at 1:00 pm
 */
export const formatLaunchTime = (tradeState, statusDates, variant) => {
  let id;
  const values = { time: null, date: null };

  const locale = renderLocale();
  const timeFormat = locale.includes('fr') ? "H 'h' mm" : "h:mm aaaaa'm";

  if (!statusDates) {
    return {};
  }

  if (
    tradeState === TradeState.upcoming &&
    (statusDates.autolaunch || statusDates.available)
  ) {
    const upcomingDate = parseISO(
      statusDates.autolaunch || statusDates.available
    );
    values.time = format(upcomingDate, timeFormat);
    switch (true) {
      case isToday(upcomingDate):
        id =
          variant === TradeViewVariant.LIST
            ? 'list.launchTime.upcoming.today'
            : 'vdp.launchTime.upcoming.today';
        break;
      case isTomorrow(upcomingDate):
        id =
          variant === TradeViewVariant.LIST
            ? 'list.launchTime.tomorrow'
            : 'vdp.launchTime.tomorrow';
        break;
      default:
        id =
          variant === TradeViewVariant.LIST
            ? 'list.launchTime.future'
            : 'vdp.launchTime.future';
        values.date = format(upcomingDate, 'iii, LLL d, yyyy');
        break;
    }
  } else if (tradeState === TradeState.pending && statusDates.pendingExpiry) {
    const pendingExpiryDate = parseISO(statusDates.pendingExpiry);
    values.time = format(pendingExpiryDate, timeFormat);

    if (isToday(pendingExpiryDate)) {
      id = 'vdp.expirationTime.pending.today';
    } else if (isTomorrow(pendingExpiryDate)) {
      id = 'vdp.expirationTime.pending.tomorrow';
    } else {
      id = 'vdp.expirationTime.pending.future';
      values.date = format(pendingExpiryDate, 'iii, LLL, d, yyyy');
    }
  } else if (
    tradeState === TradeState.active &&
    (statusDates.launched || statusDates.available)
  ) {
    const activeDate = parseISO(statusDates.launched || statusDates.available);
    values.time = format(activeDate, timeFormat);
    switch (true) {
      case isToday(activeDate):
        id =
          variant === TradeViewVariant.LIST
            ? 'list.launchTime.active.today'
            : 'vdp.launchTime.active.today';
        break;
      case isYesterday(activeDate):
        id =
          variant === TradeViewVariant.LIST
            ? 'list.launchTime.yesterday'
            : 'vdp.launchTime.yesterday';
        break;
      default:
        id =
          variant === TradeViewVariant.LIST
            ? 'list.launchTime.past'
            : 'vdp.launchTime.past';
        values.date = format(activeDate, 'iii, LLL d, yyyy');
        break;
    }
  }

  if (id && Object.keys(values).length) {
    return { id, values };
  }

  return {};
};

export const formatDistance = number => {
  let retDistance = null;
  if (Number.isInteger(number)) {
    retDistance = formatNumber(
      {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      },
      number
    );
  }

  return retDistance;
};
